import React, { Component } from 'react';
import Banner from '../../components/Agent/Banner/';
import SectionServices from '../../components/Agent/SectionServices/';
import AppSection from '../../components/Agent/AppSection';

export default class Agent extends Component {
    render() {
        const { city } = this.props;

        return (
          <React.Fragment>
            <Banner
              city={city}
              title='Приложение «Мой Дом.ру»'
              description='Управляйте услугами на экране смартфона. Доступно бесплатно в App Store и Google Play.'
              background='linear-gradient(297.76deg, #FFC224 9.32%, #FEEC8B 95.68%);'
              backgroundVector='../static/images/agent/agent-vector.svg'
            />
            <SectionServices title='Всё под рукой' />
            <AppSection />
          </React.Fragment>
        );
    }
}
